import { useIsAuthenticated, useLoggedInMember } from "@/modules/auth/states";
import ZaniaLogoLoader from "@/shared/components/page-loader";
import { ROUTES } from "@/shared/constants/routes";
import { Navigate } from "react-router-dom";
import { useFirstAccessibleRoute } from "../hooks/useFirstAccessibleRoute";

/**
 * DefaultRedirect Component
 *
 * Redirects users to the first accessible sidebar item based on their permissions.
 * Used as the catch-all route to ensure users land on a page they have access to.
 *
 * Priority order (based on mainSidebarItems):
 * 1. Compliance → /compliance/gap-assessments
 * 2. Third-Party Risk → /third-party-risk/home
 * 3. Internal Risk → /internal-risk/risk-assessments
 * 4. Ask Zania → /ask-ai
 * 5. Settings (fallback, with isDefaultRedirect marker)
 */
export default function DefaultRedirect() {
  const loggedInMember = useLoggedInMember();
  const isAuthenticated = useIsAuthenticated();
  const firstAccessibleRoute = useFirstAccessibleRoute();

  // Wait for member data when authenticated (will be fetched by App.tsx checkSession)
  if (isAuthenticated && !loggedInMember) {
    return <ZaniaLogoLoader />;
  }

  if (firstAccessibleRoute) {
    return <Navigate to={`/${firstAccessibleRoute}`} replace />;
  }

  // Fallback to settings with marker so SettingsLayout can redirect
  // if the user later gains permissions
  return <Navigate to={`/${ROUTES.SETTINGS}`} replace state={{ isDefaultRedirect: true }} />;
}
